import React, { Component } from "react";
//import * as AuthService from '../../helpers/auth';

export class AdminView extends Component {
  render() {
    return (
      <section>
        <div>
          <h1>Admin Page</h1>
        </div>
      </section>
    );
  }
}

export default AdminView;
